import { render, staticRenderFns } from "./UploadView.vue?vue&type=template&id=28357fe3&"
import script from "./UploadView.vue?vue&type=script&lang=ts&"
export * from "./UploadView.vue?vue&type=script&lang=ts&"
import style0 from "./UploadView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports